// App.js
import { VOSviewerOnline } from 'vosviewer-online';
import data1 from './datatest.json';
import data3 from './datatest2.json';
import data2 from './JOI_2007-2016_co-authorship_network.json';
import React, { useEffect, useState } from 'react';
import { getCoAuthorshipAnalysis,getInstitutionalAnalysis,getkeywordAnalysis,getCitationAnalysis } from './api'; // 导入 API 请求函数
function App() {
  // const PARENT_ORIGIN = 'http://localhost:8080'
  // const PARENT_ORIGIN = 'http://192.168.20.252:2025';
  const params = new URLSearchParams(window.location.search);
  const PARENT_ORIGIN = params.get('frameWidth') 
  ? 'https://m.evimed.com' 
  : params.get('source') 
  ? 'https://njucm.evimed.com' 
  : 'https://www.evimed.com';
  const graphId = params.get('graph');
  const language = params.get('language');
  const pid = params.get('pid');
  const words = params.get('words');
  const frameWidth = params.get('frameWidth') || '700'; // 设置默认值以防未提供参数
  const frameHeight = params.get('frameHeight') || '400'; // 设置默认值以防未提供参数
  // 确保宽度和高度带有 px 单位
  const iframeWidth = `${parseInt(frameWidth, 10)}px`;
  const iframeHeight = `${parseInt(frameHeight, 10)}px`;
  // const pid = '672325147bd44e746be0768e';
  // const words = '阿尔兹海默症';
  // const language = 1;
  const [viewerData, setViewerData] = useState(data1);
  // const [data, setData] = useState(null); // 存储 API 返回的数据
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [viewerKey, setViewerKey] = useState(0); // 用于强制重新挂载组件
  const getApiFunction = (graphId) => {
    switch(graphId) {
      case '1':
        return getCoAuthorshipAnalysis;
      case '2':
        return getInstitutionalAnalysis;
      case '3':
        return getkeywordAnalysis;
      case '4':
        return getCitationAnalysis;
      default:
        return null;
    }
  };
  const fetchAxiosData = async (languageChange) => {
    setLoading(true);
    setError(null);
    if (graphId && language !== undefined && pid && words) {
      const apiFunction = getApiFunction(graphId);
      if (!apiFunction) {
        setError('无效的 graphId');
        setLoading(false);
        return;
      }

      try {
        // 获取 token 从 URL 查询参数
        // const token = params.get('token');
        // if (!validateToken(token)) {
        //   throw new Error('无效的 token');
        // }

        // 根据 languageChange 确定语言参数
        const langParam = languageChange ? 0 : 1;

        // 调用对应的 API 函数
        const response = await apiFunction(pid, words, language);

        console.log('API 响应数据:', response.data);
        setViewerData(response.data.data);
        setViewerKey(prev => prev + 1);
        setLoading(false);

        // 假设 API 返回的数据结构中包含 'summarize'
        let answer = response.data.data.summarize || '';
        console.log(PARENT_ORIGIN);
        window.parent.postMessage(
          { type: 'ANSWER', payload: { answer }, graphId },
          PARENT_ORIGIN
        );

      } catch (err) {
        console.error('API 请求错误:', err);
        setError(err.message || 'API 请求错误');
        setLoading(false);
        window.parent.postMessage(
          { type: 'ANSWER', payload: { errinfo: err.message || 'API 请求错误' }, graphId },
          PARENT_ORIGIN
        );
      }
    } else {
      console.warn('缺少必要的查询参数');
      setLoading(false);
    }
  };
  // const fetchAxiosData = async (languageChange) => {
  //   setLoading(true);
  //   setError(null);
  //   if (graphId && language && pid && words) {
  //     getCoAuthorshipAnalysis(pid, words, languageChange?0:1)
  //     .then(response => {
  //       console.log(response.data);
  //       // setData(response.data.data);
  //       setViewerData(response.data.data);
  //       setViewerKey(prev => prev + 1);
  //       setLoading(false); 
  //       let answer = response.data.data.summarize;
  //       window.parent.postMessage(
  //         { type: 'ANSWER', payload: { answer }, graphId },
  //         PARENT_ORIGIN // 根据实际情况调整
  //       );
  //     })
  //     .catch(err => {
  //       console.error('API 请求错误:', err);
  //       setError(err.message || 'API 请求错误');
  //       setLoading(false);
  //       window.parent.postMessage(
  //         { type: 'ANSWER', payload: { errinfo: err.message || 'API 请求错误' }, graphId },
  //         PARENT_ORIGIN
  //       );
  //     });
  //   } else {
  //     console.warn('缺少必要的查询参数');
  //   }
  // };
  useEffect(() => {
    if (graphId && language && pid && words) {
      fetchAxiosData(false);
    } else {
      console.warn('缺少必要的查询参数');
    }
  }, [pid, words, language,graphId]);
  useEffect(() => {
    const handleMessage = (event) => {
      // 验证消息来源
      if (event.origin !== PARENT_ORIGIN) return;
  
      const { target, type, payload } = event.data;
      if (target !== graphId) return;
      if (type === 'QUESTION') {
        console.log(`收到来自 Vue 的问题 (图形${graphId}):`, payload.question);
        if (payload.question === '切换到中文') {
          fetchAxiosData(true); // 传递布尔值
        }else if (payload.question === '切换到英文') {
          fetchAxiosData(false); // 传递布尔值
        }
      }
    };
    // 监听来自父窗口的消息
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [graphId, PARENT_ORIGIN, pid, words, language]);


  return (
    <div style={{ 
      width: iframeWidth, 
      height: iframeHeight,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      position: 'relative'  }}>
      {loading && (
        <p style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          margin: 0,
          fontSize: '1.2em',
          fontWeight: 'bold'
        }}>加载中...</p>
      )}
      {error && (<p style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          margin: 0,
          color: 'red',
          fontSize: '1.2em',
          fontWeight: 'bold'
        }}>错误: {error}</p>
      )}
      {!loading && !error && (
        <VOSviewerOnline key={viewerKey} data={viewerData} parameters={{ scale: 1.0 }} />
      )}
    </div>
  );
}

export default App;
